/**
 * Validates an email address, a list of comma separated email addresses, or a list of newline separated email addresses.
 *
 * @param email - The email address to validate.
 * @returns True if the email address is valid, false otherwise. If the email is a list of comma separated email addresses, the function will return true if all the email addresses are valid. If the email is a list of newline separated email addresses, the function will return true if all the email addresses are valid.
 */

export function isValidEmail(email: string): boolean {
  const emailPattern =
    /^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*(?:[,\n]\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*)*$/

  return emailPattern.test(email)
}
